<template>
  <div class="b1">
    <div class="flex_between_nowrap">
      <span class="title_before side_title">EPC绑定</span>
    </div>
    <div style="padding:0px 20px 0px 24px">
      <div class="flex_between_wrap" style="margin-top:20px;">
        <div style="display:flex;margin-bottom:30px">
          <el-select
            style="margin-right:20px;"
            size="small"
            v-model="search_value"
          >
            <el-option
              v-for="item in options"
              :key="item.model"
              :label="item.label"
              :value="item.model"
            >
            </el-option>
          </el-select>
          <el-input
            size="small"
            clearable
            @clear="tableSearch"
            @keyup.enter.native="tableSearch"
            v-model="params[search_value]"
          >
            <i
              slot="suffix"
              class="el-icon-search inputIcon "
              @click.stop="tableSearch"
            ></i
          ></el-input>
          <!-- <el-input
            clearable
            placeholder="请输入单号/组织/使用人"
            size="small"
            v-model="params['search']"
            style="width:300px;"
          >
            <i
              slot="suffix"
              class="el-icon-search inputIcon "
              @click.stop="tableSearch"
            ></i>
          </el-input> -->
        </div>

        <div class="flex_end" style="margin-bottom:30px">
          <span
            :style="$dynamicColor($store.state.readyState)"
            style="margin-right:10px"
            >{{ $store.state.readyState }}</span
          >

          <el-button
            type="other"
            :style="
              $store.state.skreadyState
                ? 'background:#FA675C'
                : $store.state.readyState !== '已连接'
                ? 'background:#42B983'
                : 'background:#436BFF'
            "
            @click="takeTitlestart(!$store.state.skreadyState)"
            >{{
              $store.state.skreadyState
                ? "关闭扫描"
                : $store.state.readyState !== "已连接"
                ? "开启连接"
                : "开始扫描"
            }}</el-button
          >
          <el-button
            type="submit"
            v-show="$store.state.readyState == '已连接'"
            @click="$store.commit('WEBSOCKET_CLEAR')"
            >清空缓存</el-button
          >

          <el-popover
            placement="bottom-start"
            width="200"
            @hide="popoverHide(rfidPower)"
            trigger="click"
            :close-delay="500"
          >
            <el-tooltip
              class="item"
              effect="dark"
              content="当前发射功率,支持输入"
              placement="left"
            >
              <el-input-number
                size="small"
                style="width: 100%"
                v-model.number="rfidPower"
                :min="1"
                :max="26"
                label="发射功率"
              ></el-input-number>
            </el-tooltip>

            <el-button style="margin-left:10px" type="submit" slot="reference"
              >调整功率</el-button
            >
          </el-popover>
        </div>
      </div>
      <div
        style="margin-bottom:40px"
        :class="
          $store.state.readyState == '已连接'
            ? 'flex_between_nowrap'
            : 'flex_end'
        "
      >
        <div class="flex_end"></div>
      </div>
      <x-table
        url="/pc/asset/epc/page"
        ref="xTable"
        :axiosType="true"
        :params="params"
        :bind_callBack="bind_callBack"
      >
        <el-table-column
          :label="item.label"
          :prop="item.model"
          show-overflow-tooltip
          v-for="item in columnArr"
          :key="item.model"
        >
        </el-table-column>

        <el-table-column label="操作" width="200">
          <template slot-scope="scope">
            <el-button
              @click="bind(scope.row)"
              type="text"
              class="addColor"
              v-show="!scope.row.assetEpc"
              >绑定</el-button
            >
            <el-button
              type="text"
              @click="
                $axiosDelete(
                  '/pc/asset/update/del/epc',
                  { id: scope.row.id },
                  tableSearch,
                  '',
                  false,
                  '确定解绑EPC吗?'
                )
              "
              class="addColor"
              v-show="scope.row.assetEpc"
              >解绑</el-button
            >
            <el-button
              type="text"
              class="deleteColor"
              @click="
                $axiosDelete(
                  '/pc/asset/update/del/epc',
                  { id: scope.row.id },
                  tableSearch,
                  '',
                  false
                )
              "
              v-show="scope.row.assetEpc"
              >删除EPC</el-button
            >
          </template>
        </el-table-column>
      </x-table>
    </div>
  </div>
</template>
<script>
import { verification, numFulter, modelFulter } from "@/utils/socketFulter";
export default {
  data() {
    return {
      rfidPower: 26,
      search_value: "assetCode",
      params: {},
      options: [
        {
          label: "条码/EPC",
          model: "assetCode",
        },
        {
          label: "资产名",
          model: "assetName",
        },
      ],
      columnArr: [
        {
          label: "资产名称",
          model: "assetName",
        },
        {
          label: "资产编码",
          model: "assetCode",
        },
        {
          label: "EPC",
          model: "assetEpc",
        },
      ],
      codeArr: [],
    };
  },

  mounted() {
    this.barcode_monitor(this.barCodeCallback);
  },
  beforeDestroy() {},
  watch: {
    "$store.state.resoveMsg"(newval, oldval) {
      console.log(newval);
      if (
        newval &&
        !this.params.assetCode &&
        this.search_value == "assetCode"
      ) {
        this.$store.commit("WEBSOCKET_RFIDOFF");

        this.$set(this.params, "assetCode", newval.substr(6));
      }
    },
  },
  methods: {
    init() {
      this.$store.commit("WEBSOCKET_RFIDON");
 
      this.rfidPower = window.localStorage.getItem("zichan_power");
    },
    popoverHide(data) {
      if (this.rfidPower !== window.localStorage.getItem("zichan_power")) {
        this.$store.commit(
          "send",
          {
            data:
              "16DF04020192" +
              numFulter(data) +
              "00" +
              verification("16DF04010292" + numFulter(data) + "00"),
            code: 3,
          })
        window.localStorage.setItem("zichan_power", data);
      }
    },
    bind_callBack(data) {
      if (
        this.search_value == "assetCode" &&
        this.params.assetCode &&
        data &&
        data.length == 1
      ) {
        this.bind(data[0]);
      }
    },
    bind_submit_callBack() {
      this.$set(this.params, "assetCode", "");
      setTimeout(() => {
        this.tableSearch();
      });
    },
    bind(row) {
      this.$createDialog(this, {
        dialogConfig: { title: "EPC绑定", width: "440px" },
        namespace: "asset_epc_bind",
        whetherDestruction: true,

        assemblyConfig: {
          row,
          callBack: this.bind_submit_callBack,
        },
      });
    },
    barCodeCallback(code) {
      this.$set(this.params, "assetCode", code);
      this.tableSearch();
    },
    takeTitlestart(boolean) {
      if (this.$store.state.readyState !== "已连接" && boolean) {
        this.$store.commit("createSocket");
      } else {
        if (this.params.assetCode) {
          this.$success("开启失败:请清空EPC", "error");

          return;
        } else {
          this.$alertMsg.confirm(
            `确定${boolean ? "开始扫描" : "停止扫描"}吗？`,
            () => {
              this.$store.commit(
                "send",
                boolean
                  ? {
                      data: "16DF040201340030",
                      code: 3,
                    }
                  : {
                      data: "16DF040201350031",
                      code: 3,
                    }
              );
            }
          );
        }
      }
    },
    tableSearch() {
      this.$refs.xTable.search();
    },
  },
};
</script>
<style scoped></style>
